import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { facebookLogin, logout } from "../features/social/facebookSlice"; // Import Facebook actions
import { toast } from "react-toastify";
import { FaFacebook } from "react-icons/fa"; // Facebook icon

const FacebookLoginButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { profile, error, loading } = useSelector(
    (state) => state.facebookAuth // Get the Facebook auth state
  );

  useEffect(() => {
    // Initialize the Facebook SDK after the component has mounted
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.REACT_APP_FACEBOOK_APP_ID, // Use the Facebook App ID from         cookie: true,
        xfbml: true,
        version: "v12.0",
      });
    };

    // Load the SDK asynchronously
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  const handleFBLogin = () => {
    window.FB.login(
      function (response) {
        if (response.authResponse) {
          const accessToken = response.authResponse.accessToken;
          dispatch(facebookLogin(accessToken)); // Dispatch Facebook login action

          window.FB.api(
            "/me",
            { fields: "name,email,picture" },
            function (userInfo) {
          
              // Optionally handle user info
            }
          );
        } else {
          toast.error("User cancelled login or did not fully authorize.");
        }
      },
      { scope: "public_profile,email" }
    );
  };

  // Use profile to determine if the user is logged in and navigate to the home page
  useEffect(() => {
    if (profile) {
      navigate("/"); // Navigate to home page when profile is set
    }
  }, [profile, navigate]);

  const handleLogout = () => {
    dispatch(logout()); // Dispatch logout action
    navigate("/login");
  };

  return (
    <div>
      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {profile ? (
        <div className="d-none">
          <p>Name: {profile.name}</p>
          <br />
          <br />
          <button onClick={handleLogout}>Log out</button>
        </div>
      ) : (
        <button onClick={handleFBLogin} className="btn btn-outline-Facebook">
          <FaFacebook className="me-2" />
          Sign up with Facebook
        </button>
      )}
    </div>
  );
};

export default FacebookLoginButton;
